class TimelineUnit {

    constructor(create, destroy, duration) {
        this._duration = duration || 1;
        this.create = () => {
            if (this._constructed) return this.timeline;
            this._constructed = true;
            return create();
        };
        this.destroy = () => {
            if (!this._constructed) return null;
            this._constructed = false;
            return destroy();
        };
        this._index = -1;
        this._t0 = 0;
        this._creationDelta = 1;
        this._created = false;
        this._started = false;
        this._constructed = false;
        this.timeline = null;
    }

    set creationDelta(value) {
        if (value === void 0) return this._creationDelta;
        this._creationDelta = value;
    }

    get creationDelta() {
        return this._creationDelta;
    }

    set t0(value) {
        if (value === void 0) return this._t0;
        this._t0 = value;
    }

    get t0() {
        return this._t0;
    }

    set duration(value) {
        if (value === void 0) return this._duration;
        this._duration = value;
    }

    get duration() {
        return this._duration;
    }

    set index(value) {
        if (value === void 0 || isNaN(value)) this._index = -1;
        this._index = value;
    }

    get index() {
        return this._index;
    }

    set created(value) {
        if (value === this._created) return this._created;
        if (!this._createdChanged) this._prevCreated = this._created;
        this._created = value;
        this._createdChanged = this._prevCreated !== value;
    }

    get created() {
        return this._created;
    }

    resetCreatedChanged() {
        this._createdChanged = false;
    }

    get createdChanged() {
        return this._createdChanged;
    }

    set started(value) {
        if (value === this._started) return this._started;
        if (!this._startedChanged) this._prevStarted = this._started;
        this._started = value;
        this._startedChanged = this._prevStarted !== value;
    }

    get started() {
        return this._started;
    }

    get startedChanged() {
        return this._startedChanged;
    }

    resetStartedChanged() {
        this._startedChanged = false;
    }
}

module.exports = TimelineUnit;


// WEBPACK FOOTER //
// ./js/viscom/viscomjs/flexTimeline/TimelineUnit.js